import type { SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Hollow Pines',
    description: 'A walk-around pixel field station on Marrow Ridge: read the casebook, check the trail cameras, file a sighting and ride the ridge before the light goes.',
    url: getOrigin(),
    ogImage: '/images/og-cover.jpg'
}
